import { useAtomValue } from 'jotai';
import { questionnaireDetailsMapAtom } from '../../modernization-common/side-panel/atoms/questionnaire.atom';
import type { EntityTaggingAnnotationT } from '../types';
import { getEntityTaggingPendingAnnotations } from '../utils/pending-utils';
export const useEntityTaggingPendingAnnotations = (annotationList: (EntityTaggingAnnotationT & {
  id: string;
})[], validations: {
  maxSegmentLength?: number;
  minSegmentLength?: number;
}) => {
  const questionnaireCache = useAtomValue(questionnaireDetailsMapAtom);
  return getEntityTaggingPendingAnnotations(annotationList, questionnaireCache, validations);
};